// hooks/usePaymentErrorHandler.js

import { useRef, useCallback } from 'react';
import * as Sentry from '@sentry/react';
import { notifyError } from '../../../utils/Notify';

const MAX_PAYMENT_ERRORS = 2;
const RELOAD_DELAY_MS = 2000;

export const usePaymentErrorHandler = () => {
  const errorCount = useRef(0);
  const isReloading = useRef(false);

  const incrementPaymentError = useCallback((error, formattedMessage) => {
    errorCount.current += 1;

    if (errorCount.current >= MAX_PAYMENT_ERRORS && !isReloading.current) {
      isReloading.current = true;

      Sentry.captureMessage('Payzen SDK frozen after repeated payment errors - reloading', {
        level: 'warning',
        extra: {
          errorCount: errorCount.current,
          lastErrorCode: error?.errorCode || error?.detailedErrorCode,
          lastErrorMessage: error?.errorMessage,
          paymentMeRELOAD_DELAY_MSthod: error?.paymentMethod,
        },
      });

      notifyError(
        formattedMessage || 'Erreur de paiement',
          'Tentatives max atteintes. La page va être rechargée.'
      );
      console.info('ERROR PAYMENT', error)
      setTimeout(() => {
        window.location.reload();
      }, RELOAD_DELAY_MS);

      return true; // signale qu'on reload
    }

    return false; // pas de reload, continuer le flow normal
  }, []);

  const resetPaymentErrors = useCallback(() => {
    errorCount.current = 0;
  }, []);

  return { incrementPaymentError, resetPaymentErrors };
};
